import { MantineSize, rem } from '@mantine/core';

export const MantineRadiusConfig: Record<MantineSize, string> = {
  xs: rem(2),
  sm: rem(4),
  md: rem(8),
  lg: rem(16),
  xl: rem(32),
};
